import { FOCUS_KEY, saveDigest, loadDigest } from "./focus-mode-hook";

const HANDSET_MEDIA_QUERY = "(max-width: 639px)";
const isHandset = () => window.matchMedia(HANDSET_MEDIA_QUERY).matches;

// Auto-dismiss delays by flash kind (ms)
const AUTO_DISMISS_DELAY = { info: 5000, error: 8000 };

function autoDismiss(flashEl) {
  if (!flashEl || flashEl.hasAttribute("hidden")) return;

  const kind = flashEl.getAttribute("data-flash-kind");

  // Don't auto-dismiss the server-error (disconnect) flash
  if (flashEl.id === "server-error") return;

  const delay = AUTO_DISMISS_DELAY[kind] || 5000;

  // Clear any existing timer to avoid double-dismiss on rapid updates
  const existingTimer = flashEl._autoDismissTimer;
  if (existingTimer) clearTimeout(existingTimer);

  flashEl._autoDismissTimer = setTimeout(() => {
    // Fade out with CSS transition
    flashEl.style.transition = "opacity 300ms ease-out, transform 300ms ease-out";
    flashEl.style.opacity = "0";
    flashEl.style.transform = "translateY(-0.5rem)";

    setTimeout(() => {
      flashEl.style.display = "none";
      // Also clear the flash on the server so it doesn't reappear on navigation
      const lv = flashEl.closest("[phx-main]") || document.querySelector("[data-phx-main]");
      if (lv && window.liveSocket) {
        window.liveSocket.execJS(flashEl, flashEl.getAttribute("phx-click"));
      }
    }, 300);
  }, delay);

  // Pause auto-dismiss on hover/touch so users can read long messages
  flashEl.addEventListener(
    "mouseenter",
    () => {
      if (flashEl._autoDismissTimer) {
        clearTimeout(flashEl._autoDismissTimer);
        flashEl._autoDismissTimer = null;
      }
    },
    { once: true }
  );
}

const FlashBatchHook = {
  mounted() {
    this.handleFlash();
    this.scheduleAutoDismiss();
  },
  updated() {
    this.handleFlash();
    this.scheduleAutoDismiss();
  },
  scheduleAutoDismiss() {
    const flashes = this.el.querySelectorAll("[data-flash-kind]");
    flashes.forEach((flash) => autoDismiss(flash));
  },
  handleFlash() {
    if (isHandset()) return;

    const focusEnabled = localStorage.getItem(FOCUS_KEY) === "true";
    if (!focusEnabled) return;

    const infoFlash = this.el.querySelector("[data-flash-kind='info']");
    if (!infoFlash) return;

    const messageEl = infoFlash.querySelector("p.mt-2");
    const message = messageEl?.textContent?.trim();
    if (!message) return;

    const digest = loadDigest();
    digest.push({ message, receivedAt: new Date().toISOString() });
    saveDigest(digest);

    infoFlash.classList.add("hidden");
  },
};

export default FlashBatchHook;
